<template>
  <div class="content">
    <div class="loader" v-if="loading">
      <loader/>
    </div>
    <div class="home-texts" v-if="!loading">
      <concept-slider></concept-slider>
      <div>
        <div class="concept-page">
          <div v-for="(concept, index) in concepts" :key="index" :index="index" :item="concept" class="concept-content"
               :class="{'light-grey': index % 2 === 1}">
            <div class="container">
              <div class="page">
                <div :class="{invest: true, noPicture: !concept.picture}" v-if="index % 2 === 1">
                  <img :src="concept.picture" v-if="concept.picture">
                  <div :class="{texteinvest: true}">
                    <h2 class="titlesection" v-if="concept.concept_text.title" v-html="concept.concept_text.title"></h2>
                    <p :class="{noTitle: !concept.concept_text.title}" v-html="concept.concept_text.content"></p>
                  </div>
                </div>
                <div :class="{pro: true, noPicture: !concept.picture}" v-else>
                  <div :class="{textepro: true}">
                    <h2 class="titlesection" v-if="concept.concept_text.title" v-html="concept.concept_text.title"></h2>
                    <p :class="{noTitle: !concept.concept_text.title}" v-html="concept.concept_text.content"></p>
                  </div>
                  <img :src="concept.picture" v-if="concept.picture">
                </div>
              </div>
            </div>
          </div>
          <router-link tag="a" :to="{name: 'home'}" style="margin: auto" class="colored-btn yellow-green-btn" v-if="parseInt(this.$route.params.conceptMenuId) === 2">
            <span>{{$t('discover.button')}}</span>
          </router-link>
          <home-blog/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import ConceptSlider from './concept-slider';
  import homeBlog from '../home/home-blog'
  import {setBodyConcept} from '../../helpers/body-class.helper';
  import Loader from '../../components/loader.component'
  import {MetaHelper} from "../../helpers/meta.helper";

  export default {
    name: 'concept',
    metaInfo () {
      return this.meta
    },
    components: {Loader, ConceptSlider, homeBlog},
    async created() {
      if (this.$route.params) {
        await this.$store.dispatch('conceptPage/fetch', this.$route.params)
      }
    },
    computed: {
      meta () {
        if (this.loading || this.concepts.length === 0) return MetaHelper.home(this.$store.state.lang.currentLang);
        return MetaHelper.concept(this.concept)
      },
      ...mapState({
        loading: state => state.conceptPage.loading,
        concepts: state => state.conceptPage.concepts,
        concept: state => state.conceptPage.concept,
        conceptMenu: state => state.menu.concept
      })
    },
    async mounted() {
      setBodyConcept();
      await this.$store.dispatch('menu/setIndexActive', 1);
    },
  };
</script>

<style scoped>

  .loader {
    height: 120px;
  }

  .button-footer {
    margin-top: 10px;
  }

  .colored-btn {
    color: var(--white);
  }

</style>



// WEBPACK FOOTER //
// src/pages/concept/concept.vue